import React from "react";
import Chart from "react-apexcharts";
import { Form, Badge } from "react-bootstrap";

const SLAComplianceChart = ({ analytics = {} }) => {
  const series = [
    analytics?.withinSLA || 148,
    analytics?.breachedSLA || 152,
  ];

  const options = {
    chart: {
      type: "donut",
      toolbar: {
        show: false,
      },
    },

    labels: [
      "Within SLA",
      "Breached SLA",
    ],

    colors: [
      "#16a34a",
      "#e52421",
    ],

    legend: {
      position: "bottom",
      horizontalAlign: "center",
      markers: {
        width: 12,
        height: 12,
      },
    },

    dataLabels: {
      enabled: false,
    },

    stroke: {
      width: 2,
      colors: ["#ffffff"],
    },

    plotOptions: {
      pie: {
        donut: {
          size: "65%",
          labels: {
            show: false,
          },
        },
      },
    },

    tooltip: {
      y: {
        formatter: (value) => `${value} Queries`,
      },
    },

    responsive: [
      {
        breakpoint: 768,
        options: {
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  return (
    <>
      <div className="p-3">
        <Chart
          options={options}
          series={series}
          type="donut"
          height={200}
        />
      </div>
    </>
  );
};

export default SLAComplianceChart;